import React, { useEffect } from 'react';
import { loadGoogleCharts } from '../../utils/googleCharts';

const TimelineChart = ({ data, id, height }) => {


  useEffect(() => {

    let cancelled = false;

    /*
     * Usa o loader compartilhado (utils/googleCharts) para que
     * exista UMA única chamada google.charts.load na aplicação.
     * Chamar load() mais de uma vez com pacotes diferentes faz o
     * loader recarregar e trocar window.google.visualization,
     * quebrando os outros gráficos ("DataTable is not a constructor").
     */
    loadGoogleCharts()
      .then(() => {
        if (!cancelled) drawChart();
      })
      .catch(() => undefined);

    function drawChart() {

      const container = document.getElementById(id);

      if (!container || !window.google?.visualization) return;
      const chart     = new window.google.visualization.Timeline(container);
      const dataTable = new window.google.visualization.DataTable();

      // Configura as colunas
      dataTable.addColumn( { type: 'string', id: 'Position'  } );
      dataTable.addColumn( { type: 'string', id: 'Name'      } );
      dataTable.addColumn( { type: 'string', id: 'style', role: 'style' });
      dataTable.addColumn( { type: 'string', role: 'tooltip', 'p': {'html': true} });
      dataTable.addColumn( { type: 'date',   id: 'Start'     } );
      dataTable.addColumn( { type: 'date',   id: 'End'       } ); 

      // Adiciona os dados
      dataTable.addRows(data);

      var options = {
        tooltip: {isHtml: true},
        timeline: { 
          
          showRowLabels:  true,    // primeira coluna com rotulos
          groupByRowLabel: true,   // permite varias barras na mesma linha
          
        },
        
        alternatingRowStyle: false // alterna as cores das linha
      
      };

      // Desenha o gráfico
      chart.draw(dataTable, options);

      // Adicionar o ouvinte para o evento select
      

    }

    return () => {
      cancelled = true;
    };
  }, [data, id]);

  return <div id={id} style={{ height: height }}></div>;
};

export default TimelineChart;
